var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.99702C0 4.84968 0.0585315 4.70837 0.162718 4.60419C0.266905 4.5 0.408213 4.44147 0.555556 4.44147H9.44444C9.59179 4.44147 9.73309 4.5 9.83728 4.60419C9.94147 4.70837 10 4.84968 10 4.99702C10 5.14437 9.94147 5.28567 9.83728 5.38986C9.73309 5.49405 9.59179 5.55258 9.44444 5.55258H0.555556C0.408213 5.55258 0.266905 5.49405 0.162718 5.38986C0.0585315 5.28567 0 5.14437 0 4.99702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39259 0.162962C5.49663 0.267129 5.55507 0.408332 5.55507 0.555555C5.55507 0.702778 5.49663 0.843981 5.39259 0.948148L1.34074 5L5.39259 9.05185C5.44717 9.10271 5.49095 9.16405 5.52132 9.23219C5.55168 9.30034 5.56801 9.37391 5.56933 9.4485C5.57064 9.5231 5.55692 9.59719 5.52898 9.66637C5.50104 9.73554 5.45945 9.79838 5.40669 9.85114C5.35394 9.90389 5.2911 9.94548 5.22192 9.97342C5.15275 10.0014 5.07865 10.0151 5.00406 10.0138C4.92946 10.0125 4.8559 9.99613 4.78775 9.96576C4.7196 9.9354 4.65827 9.89162 4.60741 9.83704L0.162962 5.39259C0.0589249 5.28843 0.000488281 5.14722 0.000488281 5C0.000488281 4.85278 0.0589249 4.71157 0.162962 4.60741L4.60741 0.162962C4.71157 0.0589249 4.85278 0.000488281 5 0.000488281C5.14722 0.000488281 5.28842 0.0589249 5.39259 0.162962Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4fab954eba27a75fd028bded430f5853.svg";
export { ForwardRef as ReactComponent };